import { WeGoConfig } from './../../shared/config';
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'wego-driver-footer',
  template: require('../views/driver-footer.component.html'),
})

export class DriverFooterComponent implements OnInit, OnDestroy {
  versionNumber: string;
  copyRightYear: number;

  constructor() { }

  ngOnInit() {
    this.versionNumber = WeGoConfig.APP_VERSION;
    this.copyRightYear=(new Date()).getFullYear();
  }

  ngOnDestroy() {

  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/driver-template/component/driver-footer.component.ts